import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[glClickedOutside]',
    standalone: false
})
export class ClickedOutsideDirective {
  @Input() public elementToIgnore: ElementRef<HTMLElement>;
  @Input() public ignoreOverlay = true;
  @Input() public ignoreClass: string;
  @Output() public glClickedOutside = new EventEmitter();
  private wasClickedInsideElement: boolean;
  private overlayClass = 'cdk-overlay-container';

  constructor(protected el: ElementRef<HTMLElement>) {}

  @HostListener('pointerdown') public onMouseDown() {
    this.wasClickedInsideElement = true;
  }

  @HostListener('document:pointerdown', ['$event']) public onDocumentClick(
    event: PointerEvent,
  ) {
    if (this.wasClickedInsideElement) {
      this.wasClickedInsideElement = false;
      return;
    }
    if (this.ignoreOverlay) {
      const excluded = document.querySelectorAll(`div.${this.overlayClass}`);
      if (excluded) {
        let excludedClicked: boolean;
        const path = event.composedPath() as HTMLElement[];
        path.forEach((element: HTMLElement) => {
          if (element.classList && element.classList.contains(this.overlayClass)) {
            excludedClicked = true;
          }
        });
        if (excludedClicked) {
          return;
        }
      }
    }
    if (this.ignoreClass) {
      const excluded = document.querySelectorAll(`div.${this.ignoreClass}`);
      if (excluded) {
        let excludedClicked: boolean;
        const path = event.composedPath() as HTMLElement[];
        path.forEach((element: HTMLElement) => {
          if (element.classList && element.classList.contains(this.ignoreClass)) {
            excludedClicked = true;
          }
        });
        if (excludedClicked) {
          return;
        }
      }
    }
    if (this.elementToIgnore) {
      if (
        !this.el.nativeElement.contains(event.target as Node) &&
        !this.elementToIgnore.nativeElement.contains(event.target as Node)
      ) {
        this.glClickedOutside.emit();
      }
    } else {
      if (!this.el.nativeElement.contains(event.target as Node)) {
        this.glClickedOutside.emit();
      }
    }
    this.wasClickedInsideElement = false;
  }
}
